import { RouterChildContext } from "react-router";

export const openCreatorContentMonitorPreview = (
  history: RouterChildContext["router"]["history"],
  monitorUuid: string,
  creatorUuid: string,
  projectId: string,
) => {
  const url = new URL(window.location.href);
  url.searchParams.set("creatorContentMonitorUuid", monitorUuid);
  url.searchParams.set("creatorUuidForMonitor", creatorUuid);
  url.searchParams.set("projectUuidForMonitor", projectId);
  history.push(url.pathname + url.search);
};

export const closeCreatorContentMonitorPreview = (
  history: RouterChildContext["router"]["history"],
) => {
  const url = new URL(window.location.href);
  url.searchParams.delete("creatorContentMonitorUuid");
  url.searchParams.delete("creatorUuidForMonitor");
  url.searchParams.delete("projectUuidForMonitor");
  history.push(url.pathname + url.search);
};
